import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { dataApi, formatApi, sourceApi, tokenStorage } from './configureApi'
import * as wordApi from './wordApi'

// import * as actionCreators from './actions'

const extras = { dataApi, formatApi, sourceApi, tokenStorage, wordApi }

const enhancers = [
  applyMiddleware(
    thunk.withExtraArgument(extras),
  ),
]

if (process.env.NODE_ENV !== 'production') {
  if (window.devToolsExtension) {
    enhancers.push(window.devToolsExtension({
      // actionCreators
    }))
  }
}

const configureStore = compose(...enhancers)(createStore)

export default configureStore



// WEBPACK FOOTER //
// ./src/configureStore.js